import { PRIORITY_OPTIONS, STATE_OPTIONS } from './constants'



/**
 * Task form schema for CreateNoteInput component (multi-column layout)
 */
export const createNoteTaskSchema = {
  column1: {
    'task.dueDate': {
      type: 'date',
      required: true,
      label: 'Due Date'
    },
    'task.taskType': {
      input: 'select',
      required: true,
      label: 'Task Type',
      selectOptions: {
        isValueObject: true,
        displayKey: 'name',
        dataApi: {
          key: 'rally.taskType',
          params: { sort: 'name' }
        }
      }
    }
  },
  column2: {
    'task.priority': {
      type: 'select',
      label: 'Priority',
      selectOptions: {
        isValueObject: false,
        data: PRIORITY_OPTIONS,
        isMulti: false
      }
    },
    'task.userId': {
      input: 'select',
      label: 'Owner',
      selectOptions: {
        isValueObject: true,
        displayKey: 'name',
        propertyValue: 'id',
        preloadFilter: true,
        minSearchChars: 3,
        dataApi: {
          key: 'rally.user',
          q: { inactive: 0 },
          params: { max: 100, sort: 'name' }
        }
      }
    }
  },
  column3: {
    'task.state': {
      input: 'select',
      label: 'State',
      selectOptions: {
        isValueObject: true,
        data: STATE_OPTIONS,
        isMulti: false
      }
    }
  }
}

/**
 * Task form schema for TodoForm component (single column layout)
 */
export const todoFormSchema = {
    ...(createNoteTaskSchema.column1),
    ...(createNoteTaskSchema.column2),
    ...(createNoteTaskSchema.column3),
    tags: {
      input: 'select',
      selectOptions: {
        isValueObject: true,
        displayKey: 'name',
        propertyValue: 'id',
        isMulti: true,
        dataApi: {
          key: 'rally.tag',
          q: {entityName: 'Activity'},
          params: { max: 100, sort: 'name' },
        }
      }
    }
  }